    package org.example.zone360.models

    import kotlinx.serialization.KSerializer
    import kotlinx.serialization.SerialName
    import kotlinx.serialization.Serializable
    import kotlinx.serialization.builtins.ListSerializer
    import kotlinx.serialization.builtins.serializer
    import kotlinx.serialization.descriptors.SerialDescriptor
    import kotlinx.serialization.encoding.Decoder
    import kotlinx.serialization.encoding.Encoder
    import kotlinx.serialization.json.JsonDecoder
    import kotlinx.serialization.json.JsonElement
    import kotlinx.serialization.json.JsonObject
    import kotlinx.serialization.json.JsonPrimitive
    import kotlinx.serialization.json.jsonArray
    import kotlinx.serialization.json.jsonObject
    import kotlinx.serialization.json.jsonPrimitive

    @Serializable
    data class GetClubCoachesResponse(
        val data: List<GetClubCoachesData>
    )

    @Serializable
    data class GetClubCoachesData(
        val count: Int = 0,
        val emphasis: String = "",
        val firstName: String = "",
        val imageUrl: String = "",
        val lastName: String = "",
        val email: String = "",
        val disabled: Boolean = false,
        val recordTime: Int = 0,
        val speakingTime: Double = 0.0,
        val totalKeywords: Int = 0,
        var efficiency: Double = 0.0,
        @Serializable(with = TeamsObjectSerializer::class)
        val teams: List<TeamsObject> = emptyList(),
        @SerialName("userID")
        val userId: String = "",
    )

    @Serializable
    data class TeamsObject(
        val seasonID: String = "",
        val teamID: String = "",
    )

    object TeamsObjectSerializer : KSerializer<List<TeamsObject>> {
        override val descriptor: SerialDescriptor =
            ListSerializer(TeamsObject.serializer()).descriptor

        override fun deserialize(decoder: Decoder): List<TeamsObject> {
            val jsonDecoder = decoder as JsonDecoder
            return jsonDecoder.decodeJsonElement().jsonArray.mapNotNull { element ->
                try {
                    // Old format: plain string → use as teamID, no seasonID
                    val teamId = element.jsonPrimitive.content
                    TeamsObject(seasonID = "", teamID = teamId)
                } catch (e: Exception) {
                    try {
                        // New format: object with seasonID and teamID
                        val obj = element.jsonObject
                        TeamsObject(
                            seasonID = obj["seasonID"]?.jsonPrimitive?.content ?: "",
                            teamID = obj["teamID"]?.jsonPrimitive?.content ?: ""
                        )
                    } catch (e: Exception) {
                        null
                    }
                }
            }.filter { it.teamID.isNotEmpty() }
        }

        override fun serialize(encoder: Encoder, value: List<TeamsObject>) {
            encoder.encodeSerializableValue(ListSerializer(TeamsObject.serializer()), value)
        }
    }